import styled from "styled-components";

export const CardContainer = styled.div`
  padding: 12px 14px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.bg.duoCoverCard};
  height: 270px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
`;

export const CardHeading = styled.h1`
  margin: 0;
  color: ${({ theme }) => (theme.name === "dark" ? "#fff" : "#121212")};
  font-size: 18px;
  font-weight: 500;
`;

export const CardParagraph = styled.p`
  margin: 0;
  color: #acacac;
  font-size: 14px;
  line-height: 18px;
  white-space: pre-wrap;
`;

export const CardLabel = styled.span`
  padding: 5px 10px;
  font-size: 12px;
  color: ${({ color }) => color};
  background: ${({ background }) => background};
  border-radius: 9999px;
  width: fit-content;
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 15;
`;

export const Image = styled.div`
  width: 143px;
  height: 164px;
  background-size: cover;
  position: absolute;
`;

export const ImageTop = styled(Image)`
  transform: rotate(15.3deg);
  z-index: 10;
  border-radius: 10px;
  bottom: -25px;
  right: 100px;
  background-image: url(${({ image }) => image});
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
`;

export const ImageBottom = styled(Image)`
  transform: rotate(-8.8deg);
  z-index: 5;
  border-radius: 10px;
  bottom: 0;
  right: 5px;
  background-image: url(${({ image }) => image});
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
`;
